import React, { useEffect, useRef } from "react";
import "./LandingPage.css";

import logoImg from "../../assets/imgs/logo.png";
import laImg from "../../assets/imgs/la.png";
import lkImg from "../../assets/imgs/lk.png";
import mmImg from "../../assets/imgs/mm.png";
import rtImg from "../../assets/imgs/rt.png";

const landingMarkup = `<!-- RIGHT SIDE NAV DOTS -->
<div class="side-nav" id="sideNav">
  <div class="sn-dot" onclick="goTo('hero')" data-section="hero"><span class="sn-label">Home</span></div>
  <div class="sn-dot" onclick="goTo('problem')" data-section="problem"><span class="sn-label">Problem</span></div>
  <div class="sn-dot" onclick="goTo('features')" data-section="features"><span class="sn-label">Features</span></div>
  <div class="sn-dot" onclick="goTo('howitworks')" data-section="howitworks"><span class="sn-label">How It Works</span></div>
  <div class="sn-dot" onclick="goTo('tech')" data-section="tech"><span class="sn-label">Technology</span></div>
  <div class="sn-dot" onclick="goTo('team')" data-section="team"><span class="sn-label">Team</span></div>
  <div class="sn-dot" onclick="goTo('contact')" data-section="contact"><span class="sn-label">Contact</span></div>
</div>

<!-- SCROLL TO TOP -->
<button class="scroll-top" id="scrollTopBtn" onclick="window.scrollTo({top:0,behavior:'smooth'})">
  <svg viewBox="0 0 18 18" fill="none"><path d="M9 14V4M4 9l5-5 5 5" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
</button>

<!-- DEMO MODAL -->
<div class="modal-overlay" id="demoModal">
  <div class="modal">
    <button class="modal-close" id="closeModal">×</button>
    <div id="formWrap">
        <h3>Book a Demo 🚀</h3>
      <p class="modal-sub">Fill in your details and we'll reach out within 24 hours to schedule your personalized Smart Cargo walkthrough.</p>
      <div class="form-row">
        <div class="fg"><label>First Name *</label><input type="text" id="f-fname" placeholder="Anar"/></div>
        <div class="fg"><label>Last Name *</label><input type="text" id="f-lname" placeholder="Həsənov"/></div>
      </div>
      <div class="fg"><label>Email Address *</label><input type="email" id="f-email" placeholder="anar@company.az"/></div>
      <div class="fg"><label>Phone Number *</label><input type="tel" id="f-phone" placeholder="+994 50 XXX XX XX"/></div>
      <div class="fg"><label>Company / Business Name *</label><input type="text" id="f-company" placeholder="Your company name"/></div>
      <div class="fg">
        <label>I am a… *</label>
        <select id="f-role">
          <option value="">Select your role</option>
          <option>Logistics / Delivery Company</option>
          <option>E-commerce Business</option>
          <option>Courier / Driver</option>
          <option>Operations Manager</option>
          <option>Other</option>
        </select>
      </div>
      <div class="fg"><label>What challenges are you facing? (optional)</label><textarea id="f-msg" placeholder="Tell us about your delivery challenges…"></textarea></div>
      <button class="form-submit" id="submitDemo">
        Send Demo Request
        <svg width="15" height="15" viewBox="0 0 15 15" fill="none"><path d="M2 7.5h11M8 3l4 4.5-4 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </button>
      <p class="form-note">We'll contact you at the email and phone number provided. You can also reach us directly at <a href="mailto:smartcargo.baku@gmail.com" style="color:var(--teal)">smartcargo.baku@gmail.com</a> or <a href="tel:+994552693739" style="color:var(--teal)">+994(55)269-37-39</a></p>
    </div>
    <div class="form-success" id="formSuccess">
      <div class="chk">✅</div>
      <h4>Request Sent!</h4>
      <p>Thank you! We'll contact you within 24 hours to confirm your demo session. Check your email for confirmation.</p>
    </div>
  </div>
</div>

<!-- NAV -->
<nav id="nav">
  <a class="nav-login" href="/login">Log in</a>
  <ul class="nav-links">
    <li><a onclick="goTo('problem')">Problem</a></li>
    <li><a onclick="goTo('features')">Features</a></li>
    <li><a onclick="goTo('howitworks')">How It Works</a></li>
    <li><a onclick="goTo('team')">Team</a></li>
  </ul>
  <button class="nav-cta open-demo">Book a Demo
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M2 6.5h9M7 2.5l4 4-4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
  </button>
</nav>

<!-- HERO -->
<section id="hero" class="hero sec-darker">
  <div class="hero-dots"></div>
  <div class="orb o1"></div><div class="orb o2"></div>
  <div class="hero-inner">
    <div>
      <div class="badge"><div class="badge-dot"></div><span>Live in Baku, Azerbaijan</span></div>
      <h1>Deliveries that are<br/><span class="t">actually on time,</span><br/>every time.</h1>
      <p class="hero-p">Smart Cargo connects couriers and operations teams on one intelligent platform: real-time traffic routing, live tracking, and full delivery analytics.</p>
      <div class="hero-btns">
        <button class="btn-primary open-demo">Book a Demo
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7h10M8 3l4 4-4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </button>
        <button class="btn-outline" onclick="goTo('features')">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><circle cx="7" cy="7" r="6" stroke="currentColor" stroke-width="1.5"/><path d="M5.5 4.5l4 2.5-4 2.5V4.5z" fill="currentColor"/></svg>
          See Features
        </button>
      </div>
      <div class="trust">
        <div class="avs"><div class="av a1">A</div><div class="av a2">R</div><div class="av a3">F</div><div class="av a4">E</div><div class="av a5">M</div></div>
        <div class="trust-t"><b>500+ couriers</b> across Baku onboard</div>
      </div>
    </div>
    <div>
      <div class="mockup-outer">
        <div class="fn"><div class="fn-t">📦 Package delivered!</div><div class="fn-s">Nizami St · 2 min ago</div><div class="fn-bar"><div class="fn-p"></div></div></div>
        <div class="mkp">
          <div class="mbar"><div class="md r"></div><div class="md y"></div><div class="md g"></div><div class="murl">smartcargo.az/admin/dashboard</div></div>
          <div class="mc">
            <div class="krow">
              <div class="kc"><div class="kl">Deliveries Today</div><div class="kv">1,248</div><div class="kd up">↑ 12%</div></div>
              <div class="kc"><div class="kl">Active Couriers</div><div class="kv">84</div><div class="kd up">↑ 3 now</div></div>
              <div class="kc"><div class="kl">Avg ETA</div><div class="kv">18m</div><div class="kd up">↓ 4m</div></div>
              <div class="kc"><div class="kl">On-Time Rate</div><div class="kv">94%</div><div class="kd up">↑ 8%</div></div>
            </div>
            <div class="mrow">
              <div class="map-c">
                <svg width="100%" height="138" viewBox="0 0 260 138" fill="none">
                  <rect width="260" height="138" fill="#0f1e35"/>
                  <line x1="0" y1="34" x2="260" y2="34" stroke="#1a3a8f" stroke-width=".4" opacity=".3"/>
                  <line x1="0" y1="68" x2="260" y2="68" stroke="#1a3a8f" stroke-width=".4" opacity=".3"/>
                  <line x1="0" y1="102" x2="260" y2="102" stroke="#1a3a8f" stroke-width=".4" opacity=".3"/>
                  <line x1="52" y1="0" x2="52" y2="138" stroke="#1a3a8f" stroke-width=".4" opacity=".3"/>
                  <line x1="104" y1="0" x2="104" y2="138" stroke="#1a3a8f" stroke-width=".4" opacity=".3"/>
                  <line x1="156" y1="0" x2="156" y2="138" stroke="#1a3a8f" stroke-width=".4" opacity=".3"/>
                  <line x1="208" y1="0" x2="208" y2="138" stroke="#1a3a8f" stroke-width=".4" opacity=".3"/>
                  <rect x="15" y="23" width="66" height="13" rx="3" fill="#162540"/>
                  <rect x="110" y="49" width="58" height="12" rx="3" fill="#162540"/>
                  <rect x="42" y="76" width="84" height="12" rx="3" fill="#162540"/>
                  <rect x="174" y="25" width="66" height="15" rx="3" fill="#162540"/>
                  <rect x="140" y="86" width="78" height="12" rx="3" fill="#162540"/>
                  <defs><linearGradient id="rg1" x1="34" y1="114" x2="218" y2="23" gradientUnits="userSpaceOnUse"><stop offset="0%" stop-color="#1a3a8f"/><stop offset="100%" stop-color="#00c9a7"/></linearGradient></defs>
                  <path d="M34 114 Q78 86 114 60 Q156 33 218 23" stroke="url(#rg1)" stroke-width="2" stroke-dasharray="5,4" opacity=".9"/>
                  <circle cx="34" cy="114" r="4.5" fill="#1a3a8f"/><circle cx="34" cy="114" r="9" fill="#1a3a8f" opacity=".15"/>
                  <ellipse cx="218" cy="17" rx="6" ry="8" fill="#00c9a7"/><circle cx="218" cy="17" r="2.5" fill="white"/>
                  <circle cx="140" cy="47" r="7" fill="#0f1e35" stroke="#00c9a7" stroke-width="1.5"/>
                  <text x="140" y="51" text-anchor="middle" font-size="7" fill="#00c9a7">🏍</text>
                </svg>
              </div>
              <div class="tbl">
                <div class="th-row"><div class="th">Courier</div><div class="th" style="text-align:center">Pkgs</div><div class="th" style="text-align:center">Status</div></div>
                <div class="trow"><div class="tn">Anar Həsənov</div><div class="tp">12</div><div class="sb sa">Active</div></div>
                <div class="trow"><div class="tn">Fərid Əliyev</div><div class="tp">8</div><div class="sb se">En Route</div></div>
                <div class="trow"><div class="tn">Leyla Quliyeva</div><div class="tp">15</div><div class="sb sa">Active</div></div>
                <div class="trow"><div class="tn">Rauf Babayev</div><div class="tp">0</div><div class="sb so">Offline</div></div>
                <div class="trow"><div class="tn">Nigar Hüseynova</div><div class="tp">9</div><div class="sb se">En Route</div></div>
              </div>
            </div>
          </div>
        </div>
        <div class="fp"><div class="fp-i"><svg width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M6.5 1C4.57 1 3 2.57 3 4.5c0 3.25 3.5 7.5 3.5 7.5s3.5-4.25 3.5-7.5C10 2.57 8.43 1 6.5 1zm0 5a1.5 1.5 0 110-3 1.5 1.5 0 010 3z" fill="#00c9a7"/></svg></div><div><div class="fp-t">ETA updated — 6 min</div><div class="fp-s">Traffic cleared on Tbilisi Ave</div></div></div>
      </div>
    </div>
  </div>
</section>

<div class="sdiv"></div>

<!-- CONTACT BAR -->
<div class="contact-bar">
  <div class="contact-item"><div class="contact-icon">📧</div><span>Email us:</span><a href="mailto:smartcargo.baku@gmail.com">smartcargo.baku@gmail.com</a></div>
  <div class="contact-item"><div class="contact-icon">📞</div><span>Call us:</span><a href="tel:+994552693739">+994 (55) 269-37-39</a></div>
  <div class="contact-item"><div class="contact-icon">📍</div><span>Baku, Azerbaijan</span></div>
</div>

<div class="proof">
  <span class="proof-lbl">Powered by</span>
  <div class="pp"><span class="pd" style="background:#61dafb"></span>React.js</div>
  <div class="pp"><span class="pd" style="background:#68a063"></span>Node.js</div>
  <div class="pp"><span class="pd" style="background:#00758f"></span>MySQL</div>
  <div class="pp"><span class="pd" style="background:#00c9a7"></span>OpenStreetMap</div>
  <div class="pp"><span class="pd" style="background:#eb5424"></span>Auth0</div>
  <div class="pp"><span class="pd" style="background:#e535ab"></span>REST API</div>
</div>

<div class="stats">
  <div class="sc"><div class="sn">53<span class="t">%</span></div><div class="sl">of shipping cost is last-mile</div></div>
  <div class="sc"><div class="sn">3<span class="t">x</span></div><div class="sl">faster route optimization</div></div>
  <div class="sc"><div class="sn">94<span class="t">%</span></div><div class="sl">on-time delivery rate</div></div>
  <div class="sc"><div class="sn">3</div><div class="sl">roles. one unified platform</div></div>
</div>

<div class="sdiv"></div>

<!-- PROBLEM -->
<section id="problem" class="sec sec-darker">
  <div class="sec-inner">
    <div class="stag rev">The Problem</div>
    <h2 class="rev">Baku's delivery system<br/>is <span class="t">broken.</span></h2>
    <p class="sub rev">Couriers navigate blind. Operations teams manage chaos with phone calls. There's no single source of truth.</p>
    <div class="prob-grid rev">
      <div class="prob-list">
        <div class="pi"><div class="pnum">01</div><div><h4>No real-time routing</h4><p>Couriers use basic GPS with no delivery-aware routing, causing costly delays in Baku's dense traffic.</p></div></div>
        <div class="pi"><div class="pnum">02</div><div><h4>Zero delivery visibility</h4><p>Recipients receive no live updates - no warning when packages are delayed, leading to failed deliveries.</p></div></div>
        <div class="pi"><div class="pnum">03</div><div><h4>No performance analytics</h4><p>Ops teams can't measure courier performance without a central data platform - decisions are guesswork.</p></div></div>
        <div class="pi"><div class="pnum">04</div><div><h4>Completely fragmented tools</h4><p>Couriers and dispatchers use disconnected apps - no shared data, no coordination, constant miscommunication.</p></div></div>
      </div>
      <div class="pvis">
        <div class="bn"><span class="t">53</span>%</div>
        <div class="bl">of total shipping cost is<br/>the last mile alone</div>
        <div class="divdr"></div>
        <div class="bn2"><span class="t">78</span>%</div>
        <div class="bl">of surveyed Baku residents report<br/>late deliveries with zero warning</div>
      </div>
    </div>
  </div>
</section>

<div class="sdiv"></div>

<!-- FEATURES -->
<section id="features" class="sec sec-dark">
  <div class="sec-inner">
    <div style="text-align:center" class="rev">
      <div class="stag" style="justify-content:center">Platform Features</div>
      <h2 style="text-align:center">Everything you need.<br/><span class="t">Nothing you don't.</span></h2>
      <p class="sub" style="margin:0 auto;text-align:center">Click any feature to expand and learn more.</p>
    </div>
    <div class="accord rev">
      <div class="acc" data-acc>
        <div class="acc-h"><div class="acc-ico"><svg viewBox="0 0 22 22" fill="none"><path d="M11 2C7.13 2 4 5.13 4 9c0 5.25 7 11 7 11s7-5.75 7-11c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z" fill="#00c9a7"/></svg></div>
        <div class="acc-ttl">Real-Time Delivery Tracking via SMS</div><div class="acc-badge">Customer SMS</div>
        <div class="acc-chev"><svg viewBox="0 0 13 13" fill="none"><path d="M3 4.5l3.5 4 3.5-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></div></div>
        <div class="acc-body"><div class="acc-inner"><p class="acc-desc">When a delivery is assigned, recipients automatically receive an SMS with a unique tracking link - no app needed. They follow their courier live on a map and see real-time ETA updates as traffic changes.</p><ul class="acc-pts"><li>Unique SMS tracking link per delivery</li><li>Live courier location on map</li><li>Dynamic ETA updates</li><li>Delivery confirmation notification</li></ul></div></div>
      </div>
      <div class="acc" data-acc>
        <div class="acc-h"><div class="acc-ico"><svg viewBox="0 0 22 22" fill="none"><path d="M2 11l18-8-8 18-2-8-8-2z" fill="#00c9a7"/></svg></div>
        <div class="acc-ttl">Traffic-Aware Route Optimization</div><div class="acc-badge">Courier Portal</div>
        <div class="acc-chev"><svg viewBox="0 0 13 13" fill="none"><path d="M3 4.5l3.5 4 3.5-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></div></div>
        <div class="acc-body"><div class="acc-inner"><p class="acc-desc">Integrated with OpenStreetMap and live traffic data, Smart Cargo calculates the most efficient delivery route in real time. When conditions change, routes recalculate instantly with voice alerts for couriers.</p><ul class="acc-pts"><li>OpenStreetMap integration</li><li>Live traffic recalculation</li><li>Multi-stop route optimization</li><li>Voice alert for rerouting</li></ul></div></div>
      </div>
      <div class="acc" data-acc>
        <div class="acc-h"><div class="acc-ico"><svg viewBox="0 0 22 22" fill="none"><path d="M17 18V9M11 18V3M5 18v-5" stroke="#00c9a7" stroke-width="2" stroke-linecap="round"/></svg></div>
        <div class="acc-ttl">Operations & Analytics Dashboard</div><div class="acc-badge">Admin</div>
        <div class="acc-chev"><svg viewBox="0 0 13 13" fill="none"><path d="M3 4.5l3.5 4 3.5-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></div></div>
        <div class="acc-body"><div class="acc-inner"><p class="acc-desc">Admins get a real-time operational overview - every courier, every package, every delivery status on one screen. Track delivery trends, delay patterns, and individual courier performance over time.</p><ul class="acc-pts"><li>Live courier map monitoring</li><li>Delivery KPIs & delay analysis</li><li>Courier performance scoring</li><li>Exportable reports</li></ul></div></div>
      </div>
      <div class="acc" data-acc>
        <div class="acc-h"><div class="acc-ico"><svg viewBox="0 0 22 22" fill="none"><rect x="2" y="2" width="18" height="18" rx="3" stroke="#00c9a7" stroke-width="1.8"/><path d="M6 11h10M6 7h6M6 15h8" stroke="#00c9a7" stroke-width="1.5" stroke-linecap="round"/></svg></div>
        <div class="acc-ttl">Package & Delivery Management</div><div class="acc-badge">Admin + Courier</div>
        <div class="acc-chev"><svg viewBox="0 0 13 13" fill="none"><path d="M3 4.5l3.5 4 3.5-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></div></div>
        <div class="acc-body"><div class="acc-inner"><p class="acc-desc">Full package lifecycle from warehouse intake to final delivery. Admins assign packages, set priorities, monitor real-time status. Couriers see a prioritized list and update status with one tap.</p><ul class="acc-pts"><li>Incoming & assigned package tables</li><li>Priority-based assignment</li><li>One-tap status updates</li><li>Full delivery history</li></ul></div></div>
      </div>
      <div class="acc" data-acc>
        <div class="acc-h"><div class="acc-ico"><svg viewBox="0 0 22 22" fill="none"><circle cx="11" cy="7" r="4" stroke="#00c9a7" stroke-width="1.8"/><path d="M3 19c0-4 3.58-7 8-7s8 3 8 7" stroke="#00c9a7" stroke-width="1.8" stroke-linecap="round"/></svg></div>
        <div class="acc-ttl">Courier Performance & Rating</div><div class="acc-badge">All Portals</div>
        <div class="acc-chev"><svg viewBox="0 0 13 13" fill="none"><path d="M3 4.5l3.5 4 3.5-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></div></div>
        <div class="acc-body"><div class="acc-inner"><p class="acc-desc">After every delivery, recipients rate via the SMS tracking link using quick-tap tags - no long forms. Ratings feed into transparent courier scores visible to admins, driving fair evaluation.</p><ul class="acc-pts"><li>Rating via SMS link (no app needed)</li><li>Quick-tap feedback tags</li><li>Transparent performance scores</li><li>Bias-free, data-driven evaluation</li></ul></div></div>
      </div>
      <div class="acc" data-acc>
        <div class="acc-h"><div class="acc-ico"><svg viewBox="0 0 22 22" fill="none"><rect x="2" y="10" width="18" height="10" rx="2" stroke="#00c9a7" stroke-width="1.8"/><path d="M6 10V6a5 5 0 0110 0v4" stroke="#00c9a7" stroke-width="1.8" stroke-linecap="round"/></svg></div>
        <div class="acc-ttl">Role-Based Access Control</div><div class="acc-badge">Security</div>
        <div class="acc-chev"><svg viewBox="0 0 13 13" fill="none"><path d="M3 4.5l3.5 4 3.5-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></div></div>
        <div class="acc-body"><div class="acc-inner"><p class="acc-desc">Auth0-powered authentication with strict role separation. Couriers see only their assigned deliveries. Admins have full operational access. Recipients get a secure, time-limited SMS tracking link - no account needed.</p><ul class="acc-pts"><li>Auth0 authentication</li><li>Courier & Admin portals separated</li><li>Secure SMS tracking links</li><li>HTTPS/TLS encrypted</li></ul></div></div>
      </div>
    </div>
  </div>
</section>

<div class="sdiv"></div>

<!-- HOW IT WORKS -->
<section id="howitworks" class="sec sec-darker">
  <div class="sec-inner">
    <div class="stag rev">How It Works</div>
    <h2 class="rev">Two portals.<br/><span class="t">One platform.</span></h2>
    <p class="sub rev">Smart Cargo powers two dedicated interfaces - one for couriers, one for admins. Recipients get a simple SMS link.</p>
    <div class="tabs-nav rev">
      <button class="tab-btn active" data-tab="courier"><span>🏍️</span> Courier Portal</button>
      <button class="tab-btn" data-tab="admin"><span>🖥️</span> Admin Dashboard</button>
    </div>
    <div class="tab-panel active tab-c" id="tab-courier">
      <div>
        <div class="role-badge rb-c">For Couriers</div>
        <div class="tab-h">Navigate. Deliver. Perform.</div>
        <p class="tab-desc">Couriers log in to see assigned packages in priority order, navigate with live traffic-aware routing, and update delivery status with one tap.</p>
        <ul class="tab-list">
          <li>Prioritized package list with ETA & address</li>
          <li>Traffic-aware turn-by-turn navigation</li>
          <li>Dynamic route recalculation on traffic changes</li>
          <li>One-tap package status updates</li>
          <li>Personal performance score dashboard</li>
        </ul>
        <!-- <button class="btn-primary open-demo">Book a Demo to See It Live</button> -->
      </div>
      <div class="tab-vis">
        <div class="tab-kpi">
          <div class="tk"><div class="tk-l">Today's Deliveries</div><div class="tk-v">24</div><div class="kd up">↑ 3 vs yesterday</div></div>
          <div class="tk"><div class="tk-l">Avg Delivery Time</div><div class="tk-v">22m</div><div class="kd up">↓ 5m faster</div></div>
          <div class="tk"><div class="tk-l">Rating</div><div class="tk-v">4.9⭐</div><div class="kd" style="color:var(--muted)">Last 30 days</div></div>
          <div class="tk"><div class="tk-l">On-Time Rate</div><div class="tk-v">96%</div><div class="kd up">↑ top 10%</div></div>
        </div>
        <div style="background:var(--bg2);border:1px solid var(--border);border-radius:10px;overflow:hidden;margin-top:10px">
          <svg width="100%" height="136" viewBox="0 0 310 136" fill="none">
            <rect width="310" height="136" fill="#0f1e35"/>
            <line x1="0" y1="34" x2="310" y2="34" stroke="#1a3a8f" stroke-width=".4" opacity=".3"/><line x1="0" y1="68" x2="310" y2="68" stroke="#1a3a8f" stroke-width=".4" opacity=".3"/><line x1="0" y1="102" x2="310" y2="102" stroke="#1a3a8f" stroke-width=".4" opacity=".3"/>
            <line x1="62" y1="0" x2="62" y2="136" stroke="#1a3a8f" stroke-width=".4" opacity=".3"/><line x1="124" y1="0" x2="124" y2="136" stroke="#1a3a8f" stroke-width=".4" opacity=".3"/><line x1="186" y1="0" x2="186" y2="136" stroke="#1a3a8f" stroke-width=".4" opacity=".3"/><line x1="248" y1="0" x2="248" y2="136" stroke="#1a3a8f" stroke-width=".4" opacity=".3"/>
            <rect x="18" y="22" width="78" height="13" rx="3" fill="#162540"/><rect x="132" y="52" width="68" height="12" rx="3" fill="#162540"/><rect x="54" y="78" width="96" height="12" rx="3" fill="#162540"/><rect x="206" y="26" width="84" height="15" rx="3" fill="#162540"/><rect x="164" y="88" width="86" height="12" rx="3" fill="#162540"/>
            <defs><linearGradient id="rg2" x1="40" y1="114" x2="262" y2="22" gradientUnits="userSpaceOnUse"><stop offset="0%" stop-color="#1a3a8f"/><stop offset="100%" stop-color="#00c9a7"/></linearGradient></defs>
            <path d="M40 114 Q94 86 134 58 Q184 30 262 22" stroke="url(#rg2)" stroke-width="2.5" stroke-dasharray="7,5" opacity=".95"/>
            <circle cx="40" cy="114" r="5" fill="#1a3a8f"/><circle cx="40" cy="114" r="10" fill="#1a3a8f" opacity=".15"/>
            <ellipse cx="262" cy="15" rx="7" ry="9" fill="#00c9a7"/><circle cx="262" cy="15" r="2.5" fill="white"/>
            <circle cx="155" cy="50" r="8" fill="#0f1e35" stroke="#00c9a7" stroke-width="1.5"/>
            <text x="155" y="54" text-anchor="middle" font-size="8" fill="#00c9a7">🏍</text>
            <rect x="6" y="97" width="64" height="26" rx="6" fill="#0a1526" stroke="rgba(0,201,167,.4)" stroke-width="1"/>
            <text x="38" y="108" text-anchor="middle" font-size="7" fill="#00c9a7" font-weight="600">ETA: 8 min</text>
            <text x="38" y="118" text-anchor="middle" font-size="6" fill="#64748b">Rerouting…</text>
          </svg>
        </div>
      </div>
    </div>
    <div class="tab-panel tab-a" id="tab-admin">
      <div>
        <div class="role-badge rb-a">For Administrators</div>
        <div class="tab-h">Monitor. Assign. Optimize.</div>
        <p class="tab-desc">Admins get complete operational control - real-time visibility into every courier, every package, every delivery status across the entire fleet.</p>
        <ul class="tab-list">
          <li>Live courier locations on map</li>
          <li>Incoming & assigned package management</li>
          <li>Fleet-wide KPIs and analytics</li>
          <li>Courier performance ranking & scoring</li>
          <li>Warehouse and vehicle management</li>
        </ul>
        <button class="btn-primary open-demo">Book a Demo to See It Live</button>
      </div>
      <div class="tab-vis">
        <div class="tab-kpi">
          <div class="tk"><div class="tk-l">Active Couriers</div><div class="tk-v">84</div><div class="kd up">↑ 6 since 9am</div></div>
          <div class="tk"><div class="tk-l">Pending Packages</div><div class="tk-v">312</div><div class="kd" style="color:var(--muted)">Awaiting assign</div></div>
          <div class="tk"><div class="tk-l">Delivered Today</div><div class="tk-v">1,248</div><div class="kd up">↑ 12%</div></div>
          <div class="tk"><div class="tk-l">Delayed</div><div class="tk-v">18</div><div class="kd dn">↑ needs action</div></div>
        </div>
        <div style="background:var(--bg2);border:1px solid var(--border);border-radius:10px;overflow:hidden;margin-top:10px">
          <div style="display:grid;grid-template-columns:1fr 44px 56px;gap:5px;padding:8px 12px;border-bottom:1px solid var(--border)"><div style="font-size:8px;color:var(--muted);font-weight:600;text-transform:uppercase;letter-spacing:.4px">Courier</div><div style="font-size:8px;color:var(--muted);text-align:center;font-weight:600;text-transform:uppercase;letter-spacing:.4px">Pkgs</div><div style="font-size:8px;color:var(--muted);text-align:center;font-weight:600;text-transform:uppercase;letter-spacing:.4px">Status</div></div>
          <div class="trow"><div class="tn">Anar Həsənov</div><div class="tp">12</div><div class="sb sa">Active</div></div>
          <div class="trow"><div class="tn">Fərid Əliyev</div><div class="tp">8</div><div class="sb se">En Route</div></div>
          <div class="trow"><div class="tn">Leyla Quliyeva</div><div class="tp">15</div><div class="sb sa">Active</div></div>
          <div class="trow"><div class="tn">Rauf Babayev</div><div class="tp">0</div><div class="sb so">Offline</div></div>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="sdiv"></div>

<!-- STEPS -->
<section class="sec sec-dark">
  <div class="sec-inner">
    <div style="text-align:center" class="rev">
      <div class="stag" style="justify-content:center">Simple Process</div>
      <h2 style="text-align:center">Live in <span class="t">4 steps</span></h2>
    </div>
    <div class="steps-grid rev">
      <div class="step"><div class="step-n">01</div><div class="step-ic" style="background:rgba(0,201,167,.1)">📋</div><h4>Create Account</h4><p>Business or courier signs up. Role-based onboarding gets you live in minutes.</p><div class="step-arr"><svg width="11" height="11" viewBox="0 0 11 11" fill="none"><path d="M2 5.5h7M5.5 2l3 3.5-3 3.5" stroke="#64748b" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></div></div>
      <div class="step"><div class="step-n">02</div><div class="step-ic" style="background:rgba(26,58,143,.15)">📦</div><h4>Add Packages</h4><p>Admin adds packages. The platform assigns them to available couriers by location and capacity.</p><div class="step-arr"><svg width="11" height="11" viewBox="0 0 11 11" fill="none"><path d="M2 5.5h7M5.5 2l3 3.5-3 3.5" stroke="#64748b" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></div></div>
      <div class="step"><div class="step-n">03</div><div class="step-ic" style="background:rgba(0,201,167,.1)">🗺️</div><h4>Couriers Navigate</h4><p>Couriers get optimized routes. Recipients receive an SMS link to track their delivery live.</p><div class="step-arr"><svg width="11" height="11" viewBox="0 0 11 11" fill="none"><path d="M2 5.5h7M5.5 2l3 3.5-3 3.5" stroke="#64748b" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></div></div>
      <div class="step"><div class="step-n">04</div><div class="step-ic" style="background:rgba(0,201,167,.1)">✅</div><h4>Delivered & Analyzed</h4><p>Package confirmed, recipient notified. Analytics update instantly. Scores calculated automatically.</p></div>
    </div>
  </div>
</section>

<div class="sdiv"></div>

<!-- TECH -->
<section id="tech" class="sec sec-darker" style="text-align:center">
  <div class="sec-inner">
    <div class="stag rev" style="justify-content:center">Technology</div>
    <h2 class="rev">Built on <span class="b">proven foundations</span></h2>
    <p class="sub rev" style="margin:0 auto">Modern, scalable, open-source infrastructure.</p>
    <div class="tech-pills rev">
      <div class="tp"><span class="tdot" style="background:#61dafb"></span>React.js</div>
      <div class="tp"><span class="tdot" style="background:#68a063"></span>Node.js</div>
      <div class="tp"><span class="tdot" style="background:#00758f"></span>MySQL</div>
      <div class="tp"><span class="tdot" style="background:#00c9a7"></span>OpenStreetMap</div>
      <div class="tp"><span class="tdot" style="background:#eb5424"></span>Auth0</div>
      <div class="tp"><span class="tdot" style="background:#e535ab"></span>REST API</div>
    </div>
  </div>
</section>

<div class="sdiv"></div>

<!-- TEAM -->
<!-- <section id="team" class="sec sec-dark">
  <div class="sec-inner">
    <div class="stag rev">The Team</div>
    <h2 class="rev">The people behind<br/><span class="t">Smart Cargo</span></h2>
    <p class="sub rev">Click on a team member to view their LinkedIn profile.</p>
    <div class="team-grid rev">
      <a class="tc2" href="https://www.linkedin.com/in/lala-aslan" target="_blank" rel="noopener">
        <div class="tav" style="background:linear-gradient(135deg,#1a3a8f,#2d6ef5)">LA</div>
        <h4>Lala Aslanova</h4><div class="tro">Frontend · Design · Database</div>
        <div class="tdesc">Admin dashboard, UX/UI design, database architecture, documentation</div>
        <div class="li-badge">View LinkedIn ↗</div>
      </a>
      <a class="tc2" href="https://www.linkedin.com/in/leyla-khudiyeva/" target="_blank" rel="noopener">
        <div class="tav" style="background:linear-gradient(135deg,#0ea5e9,#1a3a8f)">LK</div>
        <h4>Leyla Khudiyeva</h4><div class="tro">Frontend · Backend · Design</div>
        <div class="tdesc">Courier portal, backend services, UI design, full-stack development</div>
        <div class="li-badge">View LinkedIn ↗</div>
      </a>
      <a class="tc2" href="https://www.linkedin.com/in/muzahim-mamedov?utm_source=share_via&utm_content=profile&utm_medium=member_ios" target="_blank" rel="noopener">
        <div class="tav" style="background:linear-gradient(135deg,#00c9a7,#0ea5e9)">MM</div>
        <h4>Muzahim Mamedov</h4><div class="tro">Optimization · Database · Analytics</div>
        <div class="tdesc">Route optimization, database design, backend analytics, AI routing</div>
        <div class="li-badge">View LinkedIn ↗</div>
      </a>
      <a class="tc2" href="https://www.linkedin.com/in/ramiz-taghiyev/" target="_blank" rel="noopener">
        <div class="tav" style="background:linear-gradient(135deg,#6366f1,#1a3a8f)">RT</div>
        <h4>Ramiz Taghiyev</h4><div class="tro">Backend · Frontend</div>
        <div class="tdesc">Backend infrastructure, frontend development, API integration, system performance</div>
        <div class="li-badge">View LinkedIn ↗</div>
      </a>
    </div>
  </div>
</section> -->

<!-- TEAM -->
<section id="team" class="sec sec-dark">
  <div class="sec-inner">
    <div class="stag rev">The Team</div>
    <h2 class="rev">The people behind<br/><span class="t">Smart Cargo</span></h2>
    <p class="sub rev">Click on a team member to view their LinkedIn profile.</p>

    <div class="team-grid rev">

      <a class="tc2" href="https://www.linkedin.com/in/lala-aslan" target="_blank" rel="noopener">
        <div class="tav">
          <img src="${laImg}" alt="Lala Aslanova">
        </div>
        <h4>Lala Aslanova</h4>
        <div class="tro">Frontend · Design · Database</div>
        <div class="tdesc">Admin dashboard, UX/UI design, database architecture, documentation</div>
        <div class="li-badge">View LinkedIn ↗</div>
      </a>

      <a class="tc2" href="https://www.linkedin.com/in/leyla-khudiyeva/" target="_blank" rel="noopener">
        <div class="tav">
          <img src="${lkImg}" alt="Leyla Khudiyeva">
        </div>
        <h4>Leyla Khudiyeva</h4>
        <div class="tro">Frontend · Backend · Design</div>
        <div class="tdesc">Courier portal, backend services, UI design, full-stack development</div>
        <div class="li-badge">View LinkedIn ↗</div>
      </a>

      <a class="tc2" href="https://www.linkedin.com/in/muzahim-mamedov?utm_source=share_via&utm_content=profile&utm_medium=member_ios" target="_blank" rel="noopener">
        <div class="tav">
          <img src="${mmImg}" alt="Muzahim Mamedov">
        </div>
        <h4>Muzahim Mamedov</h4>
        <div class="tro">Optimization · Database · Analytics</div>
        <div class="tdesc">Route optimization, database design, backend analytics, AI routing</div>
        <div class="li-badge">View LinkedIn ↗</div>
      </a>

      <a class="tc2" href="https://www.linkedin.com/in/ramiz-taghiyev/" target="_blank" rel="noopener">
        <div class="tav">
          <img src="${rtImg}" alt="Ramiz Taghiyev">
        </div>
        <h4>Ramiz Taghiyev</h4>
        <div class="tro">Backend · Frontend</div>
        <div class="tdesc">Backend infrastructure, frontend development, API integration, system performance</div>
        <div class="li-badge">View LinkedIn ↗</div>
      </a>

    </div>
  </div>
</section>

<div class="sdiv"></div>

<!-- CTA -->
<section id="contact" style="padding:72px 0">
  <div class="cta-box">
<!-- <img src="${logoImg}" alt=""> -->
    <h2>Ready to deliver<br/><span class="t">smarter?</span></h2>
    <p class="cp">Book a personalized demo and see Smart Cargo in action - live, in Baku.</p>
    <div class="cta-btns">
      <button class="btn-cta open-demo">Book a Demo
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7h10M8 3l4 4-4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </button>
      <button class="btn-ctag" onclick="goTo('features')">Explore Features</button>
    </div>
  </div>
</section>

<!-- FOOTER -->
<footer>
  <div class="ft-top">
    <div class="fb-brand">
      <div class="fb-logo" onclick="goTo('hero')" style="cursor:pointer">
<img src="${logoImg}" alt="">
    </div>
      <p>Intelligent, traffic-aware last-mile delivery platform built for Baku and beyond.</p>
      <div style="margin-top:16px;display:flex;flex-direction:column;gap:8px">
        <a href="mailto:smartcargo.baku@gmail.com" style="font-size:12px;color:var(--teal);display:flex;align-items:center;gap:7px;text-decoration:none">📧 smartcargo.baku@gmail.com</a>
        <a href="tel:+994552693739" style="font-size:12px;color:var(--teal);display:flex;align-items:center;gap:7px;text-decoration:none">📞 +994 (55) 269-37-39</a>
      </div>
    </div>
    <div class="fc"><h5>Product</h5><ul>
      <li><a onclick="goTo('features')">Features</a></li>
      <li><a onclick="goTo('howitworks')">How It Works</a></li>
      <li><a onclick="goTo('tech')">Technology</a></li>
    </ul></div>
    <div class="fc"><h5>Portals</h5><ul>
      <li><a onclick="goTo('howitworks')">Courier App</a></li>
      <li><a onclick="goTo('howitworks')">Admin Dashboard</a></li>
      <li><a onclick="goTo('features')">SMS Tracking</a></li>
    </ul></div>
    <div class="fc"><h5>Company</h5><ul>
      <li><a onclick="goTo('team')">Team</a></li>
      <!-- <li><a onclick="openDemo()">Book a Demo</a></li> -->
      <li><a onclick="goTo('problem')">Our Mission</a></li>
    </ul></div>
  </div>
  <div class="ft-bot">
    <p>© 2026 Smart Cargo. All rights reserved.</p>
  </div>
</footer>`;

function LandingPage() {
    const pageRef = useRef(null);

    useEffect(() => {
        const root = pageRef.current;
        if (!root) return undefined;

        const sections = ["hero", "problem", "features", "howitworks", "tech", "team", "contact"];
        const nav = root.querySelector("#nav");
        const scrollTopBtn = root.querySelector("#scrollTopBtn");
        const dots = root.querySelectorAll(".sn-dot");
        const modal = root.querySelector("#demoModal");
        const formWrap = root.querySelector("#formWrap");
        const formSuccess = root.querySelector("#formSuccess");

        const goTo = (id) => {
            const el = root.querySelector(`#${id}`);
            if (!el) return;
            const navH = 68;
            const top = el.getBoundingClientRect().top + window.pageYOffset - navH;
            window.scrollTo({ top, behavior: "smooth" });
        };

        const openDemo = () => {
            if (!modal) return;
            modal.classList.add("open");
            document.body.style.overflow = "hidden";
        };

        const closeDemo = () => {
            if (!modal) return;
            modal.classList.remove("open");
            document.body.style.overflow = "";
            if (formWrap) formWrap.style.display = "block";
            if (formSuccess) formSuccess.style.display = "none";
        };

        window.goTo = goTo;
        window.openDemo = openDemo;
        window.closeDemo = closeDemo;

        const handleScroll = () => {
            if (nav) {
                nav.style.background = window.scrollY > 60 ? "rgba(6,13,24,0.98)" : "rgba(6,13,24,0.95)";
            }

            if (scrollTopBtn) {
                scrollTopBtn.classList.toggle("visible", window.scrollY > 400);
            }

            let cur = "";
            sections.forEach((id) => {
                const el = root.querySelector(`#${id}`);
                if (el && el.getBoundingClientRect().top <= 120) cur = id;
            });

            dots.forEach((dot) => {
                dot.classList.toggle("active", dot.dataset.section === cur);
            });
        };

        const openDemoButtons = root.querySelectorAll(".open-demo");
        const onOpenDemoClick = (e) => {
            e.preventDefault();
            e.stopPropagation();
            openDemo();
        };
        openDemoButtons.forEach((el) => el.addEventListener("click", onOpenDemoClick));

        const closeModalBtn = root.querySelector("#closeModal");
        closeModalBtn?.addEventListener("click", closeDemo);

        const onModalClick = (e) => {
            if (e.target === modal) closeDemo();
        };
        modal?.addEventListener("click", onModalClick);

        const onKeyDown = (e) => {
            if (e.key === "Escape") closeDemo();
        };
        document.addEventListener("keydown", onKeyDown);

        const submitDemo = root.querySelector("#submitDemo");
        const onSubmitDemo = () => {
            const fields = [
                { id: "f-fname", label: "First Name" },
                { id: "f-lname", label: "Last Name" },
                { id: "f-email", label: "Email" },
                { id: "f-phone", label: "Phone" },
                { id: "f-company", label: "Company" },
                { id: "f-role", label: "Role" },
            ];

            let ok = true;
            fields.forEach((field) => {
                const el = root.querySelector(`#${field.id}`);
                if (!el) return;
                if (!el.value.trim()) {
                    el.style.borderColor = "rgba(0,201,167,.6)";
                    ok = false;
                } else {
                    el.style.borderColor = "";
                }
            });

            if (!ok) return;

            const fname = root.querySelector("#f-fname")?.value || "";
            const lname = root.querySelector("#f-lname")?.value || "";
            const email = root.querySelector("#f-email")?.value || "";
            const phone = root.querySelector("#f-phone")?.value || "";
            const company = root.querySelector("#f-company")?.value || "";
            const role = root.querySelector("#f-role")?.value || "";
            const msg = root.querySelector("#f-msg")?.value || "";

            const subject = `Smart Cargo Demo Request - ${fname} ${lname}`;
            const body = `New demo request from Smart Cargo website:%0D%0A%0D%0AName: ${fname} ${lname}%0D%0AEmail: ${email}%0D%0APhone: ${phone}%0D%0ACompany: ${company}%0D%0ARole: ${role}%0D%0A%0D%0AChallenges:%0D%0A${msg || "Not specified"}`;
            window.location.href = `mailto:smartcargo.baku@gmail.com?subject=${encodeURIComponent(subject)}&body=${body}`;

            if (formWrap) formWrap.style.display = "none";
            if (formSuccess) formSuccess.style.display = "block";

            setTimeout(closeDemo, 3000);
        };
        submitDemo?.addEventListener("click", onSubmitDemo);

        const accHeaders = root.querySelectorAll("[data-acc] .acc-h");
        const onAccClick = (e) => {
            const acc = e.currentTarget.closest(".acc");
            if (acc) acc.classList.toggle("open");
        };
        accHeaders.forEach((header) => header.addEventListener("click", onAccClick));

        const tabButtons = root.querySelectorAll(".tab-btn");
        const onTabClick = (e) => {
            const btn = e.currentTarget;
            const tab = btn.dataset.tab;
            tabButtons.forEach((button) => button.classList.remove("active"));
            root.querySelectorAll(".tab-panel").forEach((panel) => panel.classList.remove("active"));
            btn.classList.add("active");
            root.querySelector(`#tab-${tab}`)?.classList.add("active");
        };
        tabButtons.forEach((button) => button.addEventListener("click", onTabClick));

        const revealItems = root.querySelectorAll(".rev");
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) entry.target.classList.add("on");
                });
            },
            { threshold: 0.12 }
        );
        revealItems.forEach((item) => observer.observe(item));

        handleScroll();
        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
            document.removeEventListener("keydown", onKeyDown);
            openDemoButtons.forEach((el) => el.removeEventListener("click", onOpenDemoClick));
            closeModalBtn?.removeEventListener("click", closeDemo);
            modal?.removeEventListener("click", onModalClick);
            submitDemo?.removeEventListener("click", onSubmitDemo);
            accHeaders.forEach((header) => header.removeEventListener("click", onAccClick));
            tabButtons.forEach((button) => button.removeEventListener("click", onTabClick));
            observer.disconnect();
            document.body.style.overflow = "";
            if (window.goTo === goTo) delete window.goTo;
            if (window.openDemo === openDemo) delete window.openDemo;
            if (window.closeDemo === closeDemo) delete window.closeDemo;
        };
    }, []);

    return (
        <div
            className="landing-page"
            ref={pageRef}
            dangerouslySetInnerHTML={{ __html: landingMarkup }}
        />
    );
}

export default LandingPage;
